<template>
  <Dialog v-model="dialogVisible" title="修改股东等级" width="420px">
    <el-form ref="formRef" v-loading="formLoading" :model="formData" :rules="rules" label-width="80px">
      <el-form-item label="股东">
        <span>{{ row?.nickname || row?.userId }}</span>
      </el-form-item>
      <el-form-item label="等级" prop="levelId">
        <el-select v-model="formData.levelId" class="w-1/1">
          <el-option v-for="l in levels" :key="l.id" :label="l.name" :value="l.id" />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :disabled="formLoading" type="primary" @click="submit">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import * as UserApi from '@/api/mall/trade/shareholder/user'
import * as LevelApi from '@/api/mall/trade/shareholder/level'

defineOptions({ name: 'ShareholderUserLevelForm' })
const emit = defineEmits(['success'])
const message = useMessage()
const dialogVisible = ref(false)
const formLoading = ref(false)
const row = ref<UserApi.ShareholderUserVO>()
const levels = ref<LevelApi.ShareholderLevelSimpleVO[]>([])
const formRef = ref()
const formData = ref<{ levelId?: number }>({})
const rules = reactive({
  levelId: [{ required: true, message: '请选择等级', trigger: 'change' }]
})

const open = async (r: UserApi.ShareholderUserVO) => {
  row.value = r
  formData.value = { levelId: r.levelId }
  levels.value = (await LevelApi.getShareholderLevelSimpleList()) || []
  dialogVisible.value = true
}

const submit = async () => {
  await formRef.value?.validate()
  formLoading.value = true
  try {
    await UserApi.updateShareholderUserLevel({ id: row.value!.id!, levelId: formData.value.levelId! })
    message.success('已更新等级')
    dialogVisible.value = false
    emit('success')
  } finally {
    formLoading.value = false
  }
}

defineExpose({ open })
</script>
